import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OffClickModule } from '@df/module-off-click/off-click.module';
@Component({
    selector: 'section1',
    templateUrl: './section1.html',
    styleUrls: ['./section1.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass, OffClickModule]
})
export class Section1Component {
    @Input()
    isCurrent?: boolean;
    @Input()
    sectionIcon?: string;
    @Input()
    sectionTitle?: string;
}
